import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IPipelineRepository } from "@domain/repositories";
import { Pipeline, Step } from "@domain/schemas/BI";

@injectable()
export class ListPipelineService {
  @inject(TYPES.IPipelineRepository)
  private _pipelineRepository!: IPipelineRepository;

  async getAsync(id: string): Promise<Pipeline> {
    return this._pipelineRepository.getAsync(id);
  }
  async getStepsAsync(pipelineId: string): Promise<Step[]> {
    return this._pipelineRepository.getStepsAsync(pipelineId);
  }
}
